import { Stack, Typography } from '@mui/material';

type MainIconProps = {
  title: string;
};
function MainIcon({ title }: MainIconProps) {
  return (
    <Stack direction="row">
      <Typography variant="h2" sx={{ fontWeight: 'regular', letterSpacing: -2.5 }}>
        a.
      </Typography>
      &nbsp;
      <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
        {title}
      </Typography>
    </Stack>
  );
}
export { MainIcon };
export type { MainIconProps };
